export interface CommandOptions {
  command?: string;
  subCommand?: string;
  filteredParams?: string[];
}
